<fc-app-header></fc-app-header>
<fc-env-ribbon></fc-env-ribbon>
<router-outlet></router-outlet>
<fc-toast></fc-toast>
<fc-spinner [overlay]="true" [show]="false" name="app-spinner"></fc-spinner>
<fc-app-footer></fc-app-footer>
